import {
  createFileRoute,
  notFound,
  Outlet,
  useLocation,
} from "@tanstack/react-router";
import {
  PageNavbar,
  PageNavbarItem,
} from "@core/components/layout/page-navbar";
import { useEffect, useRef } from "react";
import { Badge } from "web-design-system";
import { getUserOptions } from "creso-core/hooks";
import { isEmployeeUserWithEmployeeRole } from "creso-core/utils";
import { Page } from "@core/components/layout/page";

export const Route = createFileRoute("/(auth)/_headed/insights/_layout")({
  component: RouteComponent,
  loader: async ({ context }) => {
    const user = await context.queryClient.ensureQueryData(getUserOptions());
    if (isEmployeeUserWithEmployeeRole(user)) {
      throw notFound({ routeId: "__root__" });
    }
  },
});

function RouteComponent() {
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  const location = useLocation();

  useEffect(() => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = 0;
    }
  }, [location.pathname, location.searchStr]);

  return (
    <Page>
      <Page.Content ref={scrollContainerRef}>
        <PageNavbar className="sticky top-0 z-2 bg-background shrink-0 flex items-center justify-between gap-3">
          <div className="flex items-center gap-6">
            <PageNavbarItem
              activeOptions={{ exact: true, includeSearch: false }}
              to="/insights"
            >
              Highlights
            </PageNavbarItem>
            <PageNavbarItem
              to="/insights/aum"
              activeOptions={{ exact: true, includeSearch: false }}
            >
              AUM
            </PageNavbarItem>
            <PageNavbarItem to="/insights/sip">SIP</PageNavbarItem>
            <PageNavbarItem to="/insights/clients">Clients</PageNavbarItem>
          </div>
          <Badge
            variant="custom"
            className="tracking-wide px-3 py-1 bg-tag-grey text-tag-grey-foreground"
          >
            Updated once every day
          </Badge>
        </PageNavbar>
        <Outlet />
      </Page.Content>
    </Page>
  );
}
